package com.milta.core.localization.translations.pl

import com.milta.core.localization.OcrScanStrings

internal val OcrScan = OcrScanStrings(
    scanTitle = "Zeskanuj dokument",
    reviewTitle = "Sprawdź dane",
    fileSentSuffix = "wysłano przed chwilą",
    analysingTitle = "Odczytywanie dokumentu…",
    analysingSubtitle = "Wykrywamy dostawy na zdjęciu. To zajmie tylko kilka sekund.",
    deliveriesDetectedSuffix = "wykrytych dostaw",
    toCompleteSuffix = "do uzupełnienia",
    reviewHint = "Uzupełnij oznaczone dostawy przed dodaniem ich do trasy",
    addressMissingWarning = "Brak adresu",
    nameMissingWarning = "Brak nazwiska",
    recipientMissingPlaceholder = "Odbiorca nie wykryty",
    phoneNotDetectedNote = "Telefon nie wykryty — nie blokuje dodania",
    deadlineLabelPrefix = "Godzina graniczna",
    completeLinkLabel = "Uzupełnij",
    addToRouteButtonPrefix = "Dodaj do trasy",
    correctionRecipientLabel = "Odbiorca",
    correctionAddressLabel = "Adres",
    correctionPhoneLabel = "Telefon",
    correctionDeadlineLabel = "Godzina graniczna",
    unreadableTitle = "Zdjęcie nieczytelne.",
    unreadableMessage = "Nie wykryliśmy żadnej dostawy na tym zdjęciu — zrób nowe, dobrze wykadrowane i dobrze oświetlone zdjęcie.",
    retakePhotoButton = "Zrób nowe zdjęcie",
    manualEntryButton = "Wprowadź ręcznie",
    rateLimitTitle = "Wykonano ostatnio zbyt wiele skanów.",
    rateLimitMessage = "Spróbuj ponownie trochę później lub uzupełnij tę dostawę ręcznie w międzyczasie.",
    rateLimitRetakeUnavailableLabel = "Zrób nowe zdjęcie — chwilowo niedostępne",
)
